export function formatPeso(value) {
  return new Intl.NumberFormat('en-PH', {
    style: 'currency',
    currency: 'PHP',
    maximumFractionDigits: 0,
  }).format(Number(value || 0));
}

export function formatShortDate(value) {
  if (!value) {
    return '-';
  }

  return new Date(value).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

export function formatNumericDate(value) {
  if (!value) {
    return '-';
  }

  const normalizedValue = String(value).slice(0, 10);
  const [year, month, day] = normalizedValue.split('-');

  if (year && month && day) {
    return `${month.padStart(2, '0')}-${day.padStart(2, '0')}-${year}`;
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return '-';
  }

  return [
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0'),
    date.getFullYear(),
  ].join('-');
}
